import { TActivity } from '~/utils/airtable/types/types';

export function renderFullPath(imageName = ''): string {
  const path = `/dinamic/${imageName}`;
  const imageUrl = new URL(path, import.meta.url);
  return imageUrl.href;
}

export function compareByOrder(a: TActivity, b: TActivity) {
  return a.order - b.order;
}
